import React, { Component, Fragment } from 'react'
import { prUrl } from './config.js'
import { Card, Typography, Switch } from 'antd'
import { translate } from '../utils'

const { Title } = Typography;

export default class News extends Component {
    render() {
        const { chnNewsList, engNewsList } = this.props
        return (
            <Fragment>
                {chnNewsList && chnNewsList.length > 0 ? chnNewsList.slice(0, 5).map(news => <NewsCard news={news} key={news.guid} language={'zh'} />) : ''}
                {engNewsList && engNewsList.length > 0 ? engNewsList.slice(0, 10 - (chnNewsList.length < 5 ? chnNewsList.length : 5)).map(news => <NewsCard news={news} key={news.guid} language={'en'} />) : ''}
            </Fragment>
        )
    }
}

class NewsCard extends Component {
    state = { transed: false, loading: false, transText: '' }
    setTransResult = (t) => {
        this.setState({ transText: t, transed: true, loading: false })
    }

    trans = () => {
        if (this.state.transed) {
            this.setState({ transed: false, loading: false })
        } else {
            this.setState({ loading: true })
            translate(this.props.news.title.split(" - ", 2)[0], this.setTransResult)
        }
    }

    render() {
        const { news, language } = this.props
        var restText
        var textArr = this.props.news.title.split(" - ", 2)
        if (textArr.length > 1) {
            restText = textArr.slice(1, textArr.length).join(" - ")
        } else {
            restText = ''
        }
        return (
            <Card title={<Title level={5}><a href={prUrl + news.encryptedUrl} target='blank'>{this.state.transed ? this.state.transText + " - " + restText : news.title}</a></Title>}
                extra={language !== 'zh' ? <Switch checkedChildren="中" unCheckedChildren="英" checked={this.state.transed} loading={this.state.loading} onClick={this.trans} size={'small'}/> : ''} 
                size="small" align='left'>
                <label style={{ "display": news.time ? '' : 'none' }}>发布时间：{news.time}</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <label style={{ "display": news.site ? '' : 'none' }}>来源网站：{news.site}</label>
            </Card>
        )
    }
}